(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hub-machine"] && !Shopify.designMode) return;
  try {
    (function () {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : 1;
    if (!cur || !rate || rate === 1) return;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: cur.active, maximumFractionDigits: 0
      });
    } catch (e) { return; }
    document.querySelectorAll('.hub-machine__roi[data-roi-price]').forEach(function (box) {
      var price = parseFloat(box.dataset.roiPrice) / 100;
      var wage = parseFloat(box.dataset.roiWage) * rate;
      var days = parseFloat(box.dataset.roiDays);
      var extra = parseFloat(box.dataset.roiExtra || 0) * rate;
      box.querySelectorAll('tr[data-roi-hours]').forEach(function (row) {
        var saved = parseFloat(row.dataset.roiHours) * wage * days + extra;
        if (!(saved > 0)) return;
        row.querySelector('[data-roi-saved]').textContent = fmt.format(saved);
        var months = Math.round((price / saved) * 10) / 10;
        row.querySelector('[data-roi-payback]').textContent = box.dataset.roiMonths.replace('__V__', months);
      });
      var note = box.querySelector('[data-roi-note]');
      if (note) note.textContent = note.textContent.replace(box.dataset.roiWageText, fmt.format(wage));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    const megamenu = document.querySelector('[data-megamenu]');
  const backdrop = document.querySelector('[data-megamenu-backdrop]');
  const trigger = document.querySelector('[data-megamenu-trigger]');
  const columns = document.querySelector('[data-megamenu-columns]');

  if (megamenu && trigger) {
    let openTimer, closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      megamenu.hidden = false;
      requestAnimationFrame(() => backdrop.classList.add('is-visible'));
    };

    const close = () => {
      clearTimeout(openTimer);
      backdrop.classList.remove('is-visible');
      megamenu.hidden = true;
    };

    const scheduleOpen = () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, 150);
    };

    const scheduleClose = () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, 300);
    };

    trigger.addEventListener('mouseenter', scheduleOpen);
    trigger.addEventListener('mouseleave', scheduleClose);

    megamenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    megamenu.addEventListener('mouseleave', scheduleClose);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !megamenu.hidden) close();
    });
    backdrop.addEventListener('click', close);

    const pane = megamenu.querySelector('.megamenu__image-pane');
    if (pane) {
      const images = pane.querySelectorAll('.megamenu__image');
      const defaultImg = pane.querySelector('.megamenu__image--default');

      megamenu.querySelectorAll('.megamenu__link-wrap[data-link-handle]').forEach(wrap => {
        wrap.addEventListener('mouseenter', () => {
          images.forEach(img => img.classList.remove('is-active'));
          const target = pane.querySelector('.megamenu__image[data-link-handle="' + wrap.dataset.linkHandle + '"]');
          (target || defaultImg).classList.add('is-active');
        });
      });

      if (columns) {
        columns.addEventListener('mouseleave', () => {
          images.forEach(img => img.classList.remove('is-active'));
          if (defaultImg) defaultImg.classList.add('is-active');
        });
      }
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-drawer"] && !Shopify.designMode) return;
  try {
    const drawer = document.querySelector('[data-drawer]');
  const trigger = document.querySelector('[data-drawer-trigger]');

  if (drawer && trigger) {
    function toggleDrawer(open) {
      drawer.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    trigger.addEventListener('click', () => toggleDrawer(drawer.hidden));

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.hidden) toggleDrawer(false);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // «Add to spec» from a grid card. The line goes into the visitor's spec (assets/spec-store.js,
  // loaded site-wide) — no network call, so the answer is immediate: the label flashes and the
  // toast at the bottom of the screen offers the way to the list.
  //
  // Event-delegated on document so one listener covers every card in the grid — the snippet's
  // javascript tag is deduplicated by Shopify, so this runs once per page no matter how many
  // cards render.
  (function () {
    if (window.__bqProductCardSpecBound) return;
    window.__bqProductCardSpecBound = true;

    var HOLD_MS = 2000;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-card-add-spec]');
      if (!btn || !window.BQSpec) return;

      // Lock the button width to its current size so swapping the label never reflows the card.
      if (btn.dataset.widthLocked !== '1') {
        var rect = btn.getBoundingClientRect();
        if (rect.width > 0) {
          btn.style.minWidth = Math.ceil(rect.width) + 'px';
          btn.dataset.widthLocked = '1';
        }
      }

      var moq = parseInt(btn.dataset.moq, 10) || 1;
      window.BQSpec.add({
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        url: btn.dataset.url,
        image: btn.dataset.image || null,
        category: btn.dataset.category || null,
        customizable: btn.dataset.customizable === 'true',
        moq: moq,
        qty: moq,
        variant_id: btn.dataset.variantId || null,
        variant_title: btn.dataset.variantTitle || null,
        price: parseInt(btn.dataset.price, 10),
      });
      window.BQSpec.toast();

      var labelAdd = btn.dataset.labelAdd || 'Add to spec';
      var labelAdded = btn.dataset.labelAdded || '✓ In your spec';
      btn.textContent = labelAdded;
      btn.classList.add('product-card__cta--added');
      window.clearTimeout(btn.__bqTimer);
      btn.__bqTimer = window.setTimeout(function () {
        btn.textContent = labelAdd;
        btn.classList.remove('product-card__cta--added');
      }, HOLD_MS);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-context-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrappers = document.querySelectorAll('[data-product-tabs]');
    wrappers.forEach(function (wrapper) {
      // Single-tab mode: nothing to wire — CSS handles display, no buttons exist.
      if (wrapper.hasAttribute('data-single-tab')) return;

      var buttons = wrapper.querySelectorAll('[role="tab"]');
      if (buttons.length === 0) return;

      function activate(tab, opts) {
        opts = opts || {};
        wrapper.dataset.active = tab;
        buttons.forEach(function (b) {
          var isActive = b.dataset.tab === tab;
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          b.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        // URL sync without reload (so refresh / share preserves choice).
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('tab', tab);
          history.replaceState({}, '', url);
        } catch (e) { /* ignore */ }

        if (opts.scroll) {
          var panel = wrapper.querySelector('[data-tab-content="' + tab + '"]');
          if (panel) {
            var styles = getComputedStyle(document.documentElement);
            /* --header-height is in rem; the offset below is in px. Without the
               root-font-size conversion this landed the panel under the header. */
            var rootPx = parseFloat(styles.fontSize) || 16;
            var headerH = (parseFloat(styles.getPropertyValue('--header-height')) || 0) * rootPx;
            var top = panel.getBoundingClientRect().top + window.scrollY - headerH - 16;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }

        if (opts.focus) {
          var activeBtn = wrapper.querySelector('[data-tab="' + tab + '"]');
          if (activeBtn) activeBtn.focus();
        }
      }

      buttons.forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          activate(btn.dataset.tab, { scroll: false });
        });

        // Keyboard nav (ArrowLeft / ArrowRight / Home / End) per WAI-ARIA tabs pattern.
        btn.addEventListener('keydown', function (e) {
          var target = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            target = buttons[(idx + 1) % buttons.length];
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            target = buttons[(idx - 1 + buttons.length) % buttons.length];
          } else if (e.key === 'Home') {
            target = buttons[0];
          } else if (e.key === 'End') {
            target = buttons[buttons.length - 1];
          }
          if (target) {
            e.preventDefault();
            activate(target.dataset.tab, { focus: true });
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    var section = document.querySelector('[data-reviews-initial]');
    if (!section) return;

    var initialCount = parseInt(section.dataset.reviewsInitial, 10) || 2;
    var button = section.querySelector('[data-reviews-load-more]');
    var label = section.querySelector('[data-reviews-load-more-label]');
    if (!button || !label) return;

    // Templates come from data attributes: Liquid is not rendered inside a javascript block.
    var showTemplate = button.dataset.reviewsLoadMoreTemplate || 'Show more reviews';
    var collapseLabel = button.dataset.reviewsCollapseLabel || 'Hide reviews';
    var showLabel = '';   // populated each time we recount
    var lastCount = -1;   // memo to skip no-op updates

    function updateButton() {
      var items = section.querySelectorAll('.jdgm-masonry-grid__masonry-item');
      var total = items.length;
      if (total === lastCount) return;
      lastCount = total;

      var hiddenCount = total - initialCount;

      if (hiddenCount <= 0) {
        // Not enough to expand — hide the button + reset state so a future
        // filter that re-adds reviews can show it again.
        button.hidden = true;
        section.classList.remove('is-expanded');
        return;
      }

      showLabel = showTemplate.replace('__COUNT__', hiddenCount);
      label.textContent = section.classList.contains('is-expanded') ? collapseLabel : showLabel;
      button.hidden = false;
    }

    // Keep observer alive — Judge.me filters/sorts re-render the masonry,
    // changing item count, and the button must follow. Throttle via rAF
    // so a burst of mutations triggers only one recount.
    var rafPending = false;
    var observer = new MutationObserver(function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        updateButton();
      });
    });
    observer.observe(section, { childList: true, subtree: true });

    button.addEventListener('click', function () {
      var nowExpanded = section.classList.toggle('is-expanded');
      label.textContent = nowExpanded ? collapseLabel : showLabel;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
